import {
  ELIGIBILITY_FILE_JOB_STATUSES,
  type EligibilityFileJobStatus,
} from 'tio-data/data/resources/eligibility-file-job-log.constants';

// Display names only — the status vocabulary itself, and every partition of it
// the apps branch on, lives with the resource in tio-data. Typing this as a
// total Record makes a status added there a compile error here until it has a
// label, rather than a silently unlabelled filter option.
const eligibilityFileStatusesDisplayNames: Record<EligibilityFileJobStatus, string> = {
  EXECUTING_TASKS: 'Processing',
  FAILED_VALIDATION: 'Failed Validation',
  REQUIRES_REVIEWER_APPROVAL: 'Ready for Processing (Reviewer Approval)',
  QUEUED_OFFHOURS: 'Queued (Off Hours)',
  QUEUED: 'Queued',
  REQUIRES_USER_APPROVAL: 'Ready for Processing (User Approval)',
  COMPLETED: 'Completed',
  STARTED: 'Started',
  ERROR_REPORTED: 'Error Reported',
  ABORTED_AS_DUPLICATE: 'Aborted as Duplicate',
  ABORTED_BY_ADMIN: 'Aborted by Admin',
  ABORTED_BY_REVIEWER: 'Aborted by Reviewer',
  ABORTED_BY_USER: 'Aborted by User',
  ABORTED_FOR_STALENESS: 'Aborted for Staleness',
  ABORTED_UPLOAD_DISABLED: 'Aborted (Upload Disabled)',
  ABORTED_PARTNER_DEACTIVATED: 'Aborted (Partner Deactivated)',
  VALIDATING_ELIGIBILITY_FILE: 'Validating Eligibility File',
  WAITING_FOR_UPLOAD: 'Waiting for Upload',
  TEST_COMPLETED: 'Test Completed',
};

export const statusOptions = Object.values(eligibilityFileStatusesDisplayNames);

export function statusFromDisplayName(displayName: string) {
  return ELIGIBILITY_FILE_JOB_STATUSES.find(
    (status) => eligibilityFileStatusesDisplayNames[status] === displayName
  );
}

export default null; // silence a false warning
